// 회원가입
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
// 로그인
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_WITH_TOKEN_REQUEST = 'LOGIN_WITH_TOKEN_REQUEST';
export const LOGIN_WITH_TOKEN_SUCCESS = 'LOGIN_WITH_TOKEN_SUCCESS';
export const LOGIN_WITH_TOKEN_FAIL = 'LOGIN_WITH_TOKEN_FAIL';

export const GOOGLE_LOGIN_REQUEST = 'GOOGLE_LOGIN_REQUEST';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_FAIL = 'GOOGLE_LOGIN_FAIL';

export const KAKAO_LOGIN_REQUEST = 'KAKAO_LOGIN_REQUEST';
export const KAKAO_LOGIN_SUCCESS = 'KAKAO_LOGIN_SUCCESS';
export const KAKAO_LOGIN_FAIL = 'KAKAO_LOGIN_FAIL';

export const NAVER_LOGIN_REQUEST = 'NAVER_LOGIN_REQUEST';
export const NAVER_LOGIN_SUCCESS = 'NAVER_LOGIN_SUCCESS';
export const NAVER_LOGIN_FAIL = 'NAVER_LOGIN_FAIL';

// 비밀번호 재설정 메일 전달
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
// 비밀번호 재설정
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

//비밀번호 재설정 토큰 체크
export const CHECK_RESET_TOKEN_REQUEST = 'CHECK_RESET_TOKEN_REQUEST';
export const CHECK_RESET_TOKEN_SUCCESS = 'CHECK_RESET_TOKEN_SUCCESS';
export const CHECK_RESET_TOKEN_FAIL = 'CHECK_RESET_TOKEN_FAIL';

// 마이페이지 비밀번호 변경 전 현재 비밀번호 묻고 넘어가기
export const VERIFY_CURRENT_PASSWORD_REQUEST =
  'VERIFY_CURRENT_PASSWORD_REQUEST';
export const VERIFY_CURRENT_PASSWORD_SUCCESS =
  'VERIFY_CURRENT_PASSWORD_SUCCESS';
export const VERIFY_CURRENT_PASSWORD_FAIL = 'VERIFY_CURRENT_PASSWORD_FAIL';

// 유저 비밀번호 수정
export const USER_CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_PASSWORD_FAIL = 'USER_CHANGE_PASSWORD_FAIL';

export const LOGOUT = 'LOGOUT';
export const RESET_ERROR = 'RESET_ERROR';

// 유저 정보 가져오기
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';
// 유저 정보 수정하기
export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL';
// 회원 리스트 가져오기 (admin)
export const GET_USER_LIST_REQUEST = 'GET_USER_LIST_REQUEST';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAIL = 'GET_USER_LIST_FAIL';
// 선택된 회원 정보 수정하기 (admin)
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const USER_LEVELS = ['normal', 'gold', 'suspend'];
export const UPDATE_LEVEL_REQUEST = 'UPDATE_LEVEL_REQUEST';
export const UPDATE_LEVEL_SUCCESS = 'UPDATE_LEVEL_SUCCESS';
export const UPDATE_LEVEL_FAIL = 'UPDATE_LEVEL_FAIL';

// 회원 탈퇴
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';
